import script from "./NotificationsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsModal.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsModal.vue?vue&type=style&index=0&id=4b826297&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b826297"]])

export default __exports__